import React from "react";
import CompensationRouter from './compensation/Router';
export { getFields, getReplyFields } from './compensation/Router';
export { getQuoteFields, getQuoteReplyFields } from './quotes/Router';

export default function CompensationClaimRouter(props) {
    return <CompensationRouter {...props} mode='SHORT' />;
}